import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import {AssetGroup, Asset, searchAssets} from '@deviceinsight/ng-ui-api-client';
import {SearchConfig} from '../types';
import {assetFields} from '../fields';
import FilterTable from '../FilterTable';
import columnDefs from './columnDefs';
type Props = {
	assetGroup?: AssetGroup;
	gatewayId?: number;
	onSelectAsset: (arg0: Asset) => any;
	title?: React.ReactNode | string;
};
const SEARCH_CONTEXT = 'assetGroupAssignedAssets';

const SingleAssetSelectionTable: React.FC<Props> = ({assetGroup, gatewayId, onSelectAsset, title}) => {
	const getSearchConfig = React.useCallback((): SearchConfig<Asset> => {
		return {
			fields: assetFields,
			search: (query, paginationSettings) => {
				let fullQuery;

				if (assetGroup) {
					fullQuery = `${query} transitiveAssetGroupId:${assetGroup.id}`;
				} else if (gatewayId) {
					fullQuery = `${query} gatewayId:${gatewayId}`;
				} else {
					fullQuery = query;
				}

				return searchAssets(fullQuery, paginationSettings);
			}
		};
	}, [assetGroup, gatewayId]);

	const getColumnDefs = React.useCallback(
		(): Array<ReactableColumnDef<Asset>> =>
			columnDefs().map((columnDef) => ({...columnDef, onClick: onSelectAsset})),
		[onSelectAsset]
	);

	const searchConfig = getSearchConfig();

	return (
		<div>
			<h2>{title ? title : <Trans i18nKey="rules.singleAssetSelectionTableTitle">Select Asset</Trans>}</h2>
			<FilterTable
				searchContext={SEARCH_CONTEXT}
				searchConfig={searchConfig}
				columnDefinitions={getColumnDefs()}
				pageSize={10}
				uniqueItemKey={(asset) => asset.id}
			/>
		</div>
	);
};

export default SingleAssetSelectionTable;
